import React from 'react';

import { notEmpty, mapIndexed } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const ClassifierFields = ({ classifiers }) => notEmpty(classifiers) ? (
    <div className="m-t-10">
        <DefinitionHeader translate="classifier" iconType="folder" />
        <div className="panel-view">
            <ul className="m-l-15 classifier-fild-list">
                { classifiers.map((classifier, row) => (
                    <li key={row} className="classifier-fild-block">
                        <b>{ classifier.name }</b>
                        <ul>
                            { mapIndexed((part, column) => (
                                <li key={column}>
                                    {part.text}
                                </li>
                            ), classifier.parts || [])}
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    </div>
) : null;

export default ClassifierFields;
